// extracted by mini-css-extract-plugin
export var canvas = "_8-1";
export var container = "_8-0";
export var fallback = "_8-2";